export const commonStrings = {
  words: {
    success: 'Erfolg',
    error: 'Fehler',
    warning: 'Warnung',
    back: 'Zurück',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    show: 'Anzeigen',
    cancel: 'Abbrechen',
    close: 'Schließen',
    save: 'Speichern',
    reset: 'Zurücksetzen',
    yes: 'Ja',
    no: 'Nein',
    all: 'Alle',
    actions: 'Aktionen',
    ok: 'OK',
    preview: 'Vorschau',
    baseData: 'Stammdaten',
  },
  archive: {
    archive: 'Archivieren',
    restore: 'Wiederherstellen',
    showArchived: 'Archivierte anzeigen',
    archived: 'Archiviert',
  },
  phrases: {
    retry: 'Erneut versuchen',
    noSelection: 'Keine Auswahl',
  },
  menu: {
    otherLists: 'Andere Listen',
    collapse: 'Menü einklappen',
    expand: 'Menü ausklappen',
    version: 'Installierte Version',
  },
};
